import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";

import Header from "./Components/Header";
import Help from "./Pages/Help";
import Home from "./Pages/Home";
import PageNotFound from "./Pages/PageNotFound";
import Report from './Pages/Report';
import Tool from "./Pages/Tool";

function App() {
    const theme = extendTheme({
        fonts: {
            heading: `'Poppins', sans-serif`,
            body: `'Poppins', sans-serif`,
        },
        fontWeights: {
            normal: 300,
            medium: 400,
            bold: 500,
        },
        colors: {
            blue: {
                50: "#b4c8f3",
                100: "#BEE3F8", //#88a7ec
                200: "#7297e9",
                300: "#5c87e6",
                400: "#4677e2",
                500: "#2159d4",
                600: "#1a46a8",
                700: "#173d92",
                800: "#13347c",
                900: "#0c2150",
            },
            green: {
                50: "#34ff8b",
                100: "#C6F6D5", //#01ff6e
                200: "#00e663",
                300: "#00cd58",
                400: "#00b34d",
                500: "#008037",
                600: "#004d21",
                700: "#003416",
                800: "#001a0b",
                900: "#000000",
            },
        },
        components: {
            Button: {
                // 1. We can update the base styles
                baseStyle: {
                    fontWeight: "bold", // Normally, it is "semibold"
                },
            },
        },
    });

    return (
        <>
        <ChakraProvider theme={theme}>
            <Header></Header>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home/>} />
                    <Route path="/tool" element={<Tool/>} />
                    <Route path="/help" element={<Help/>} />
                    <Route path="/report" element={<Report/>} />
                    <Route path="/*" element={<PageNotFound/>} />
                </Routes>
            </BrowserRouter>
        </ChakraProvider>
        </>
    );
}

export default App;
